import FeeForm, { FeeFormProps } from "features/fees/form/FeeForm";
import { useFeesOverrideUpdate } from "gen/endpoints/fees/fees";
import { FeeCreateAPIDataRequest } from "gen/model/feeCreateAPIDataRequest";
import { OverrideLevelData } from "gen/model/overrideLevelData";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export interface FeeOverrideFormProps
  extends Omit<FeeFormProps, "isOverride" | "submitButtonText" | "onSubmit"> {
  feeId: string;
  overrideLevel: OverrideLevelData;
  onSuccess: () => void;
}

export const FeeOverrideForm: React.FC<FeeOverrideFormProps> = ({
  feeId,
  overrideLevel,
  onSuccess,
  fundFamilyId,
  ...props
}) => {
  const { t } = useTranslation(["fees"]);
  const { mutateAsync: overrideFee } = useFeesOverrideUpdate();

  const onSubmit = useCallback(
    async (data: FeeCreateAPIDataRequest) => {
      await overrideFee({
        fundFamilyId,
        feeId,
        data: {
          override_level: overrideLevel,
          fee_create_data: data,
        },
      });
    },
    [fundFamilyId, feeId, overrideFee, overrideLevel],
  );

  return (
    <FeeForm
      isOverride={true}
      fundFamilyId={fundFamilyId}
      submitButtonText={t("fees:override.save")}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
      {...props}
    />
  );
};
